export const Button = {
  components: {
    Button: {
      // The styles all button have in common
      baseStyle: {
        lineHeight: "1.2",
        borderRadius: "md",
        fontWeight: "semibold",
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
          boxShadow: "outline",
        },
        _disabled: {
          opacity: 0.4,
          cursor: "not-allowed",
          boxShadow: "none",
        },
        _hover: {
          _disabled: {
            bg: "initial",
          },
        },
      },
      // Two sizes: sm and md
      sizes: {
        sm: {
          fontSize: "sm",
          px: 3, // <-- px is short for paddingLeft and paddingRight
          py: 2, // <-- py is short for paddingTop and paddingBottom
        },
        md: {
          fontSize: "md",
          px: 4, // <-- these values are tokens from the design system
          py: 3, // <-- these values are tokens from the design system
        },
        lg: {
          fontSize: "lg",
          px: 6, // <-- these values are tokens from the design system
          py: 5, // <-- these values are tokens from the design system
        },
      },
      // Two variants: outline and solid
      variants: {
        outline: {
          border: "2px solid",
          borderColor: "brand.primary.500",
          color: "brand.primary.500",
        },
        primary: {
          bg: "brand.primary.500",
          color: "white",
          _hover: {
            bg: "brand.primary.600",
          },
        },
        secondary: {
          bg: "brand.secondary.500",
          color: "white",
          _hover: {
            bg: "brand.secondary.600",
          },
        },
        primaryInactive: {
          bg: "brand.primary.300",
          color: "brand.primary.600",
        },
        default: {
          bg: "white",
          color: "gray.800",
          _hover: {
            bg: "gray.400",
          },
        },
        defaultInactive: {
          bg: "gray.300",
          color: "gray.800",
          opacity: 0.5,
        },
        defaultBold: {
          bg: "gray.300",
          color: "gray.800",
          fontWeight: "bold",
          _hover: {
            bg: "gray.400",
          },
        },
        urgent: {
          bg: "red.400",
          color: "white",
          _hover: {
            bg: "red.500",
          },
        },
        kioskPrimary: {
          bg: "brand.primary.500",
          color: "white",
          _hover: {
            bg: "brand.primary.600",
            _disabled: {
              bg: "brand.primary.700",
            },
          },
        },
        kioskGhost: {
          color: "white",
          _hover: { bg: "transparent" },
          _focus: { bg: "transparent" },
          _active: { bg: "transparent" },
          _disabled: { color: "rgba(255,255,255,.3)" },
        },
      },
      // The default size and variant values
      defaultProps: {
        size: "md",
        variant: "default",
        focusBorderColor: "brand.primary.200",
      },
    },
  },
};
